<template>
  <div class="root d-inline-block">
    <div class="input-group">
      <div v-if="mode==='view'">
        <div v-if="product.haveMaterial">
          <button v-if="!options.isSelectMode" class="btn btn-secondary" @click="openModal('view')">
            <i class="icon-eye-outline"></i>
          </button>
          <div v-if="options.isSelectMode" class="badge badge-danger">دارد</div>
        </div>
        <div v-if="!product.haveMaterial" class="badge badge-success">ندارد</div>
      </div>
      <!--<input v-if="mode !== 'view'" class="form-control" @click="openModal">-->
      <button v-if="mode === 'create'" class="btn btn-success" @click="openModal('create')">
        <!--<button v-if="mode === 'create'" class="btn btn-success" @click="openModal('edir')">-->
        <i class="icon-content-duplicate"></i>
      </button>
      <button
        v-if="mode==='edit' && product.id"
        class="btn btn-secendory"
        @click="openModal('edit')"
      >
        <i class="icon-bd-pencil"></i>
      </button>
    </div>
    <b-modal
      ref="materialModal"
      id="modal-center"
      class="accounting-modal"
      centered
      size="lg"
      :title="modalTitle"
      :ok-title="'ذخیره'"
      :cancel-title="'لغو'"
      @ok="onMaterialModalOk"
    >
      <vs-table v-if="show"
                ref="materialTable"
                :params="tableParams"
                :options="tableOptions">

      </vs-table>
    </b-modal>
  </div>
</template>

<script>
  import {mapState, mapMutations, mapActions} from "vuex";
  import BaseService from "../_framework/api/BaseService.js";
  import Utils from "../_framework/utils/Utils.js";
  import VsSelect from "../_framework/VsSelect";
  import VsTableMixin from "../_framework/VsTableMixin.js";
  import DatePicker from "../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue";
  import Products from "../pages/Products.vue";
  import EventBus from "../bus.js";
  import ClientSelect from "../components/ClientSelect.vue";

  export default {
    name: "select-intermediate-products",
    props: {
      headerKey: null,
      row: null,
      mode: {
        default: "view",
        type: String
      },
      params: {},
      options: {},
      entity: ""
    },
    mixins: [VsTableMixin],
    components: {
      VsSelect,
      datePicker: DatePicker
    },
    data() {
      return {
        show: false,
        product: {},
        modalTitle: "محصولات میانی",
        documentDate: null,
        servicesList: [],
        selectedServices: [],
        service: {
          id: 0,
          title: "",
          price: "",
          sessionQuantity: "",
          description: ""
        },
        doc: {
          id: 0,
          number: "",
          documentId: "",
          date: "",
          attachment: "",
          description: "",
          total: "",
          moein: "",
          tafzili: "",
          remaining: ""
        },
        tableParams: {
          list: [],
          entity: "Materials",
          headers: {
            // id: {
            //   title: "ردیف",
            //   type: "number",
            //   grow: 0.5,
            //   isSearchable: false,
            //   inHeader: false
            // },
            material: {
              title: "نام کالا",
              type: "custom",
              component: ClientSelect,
              multiple: false,
              label: "productName",
              inHeader: true,
              listParams: {
                requestURI: "products/GetDropDownModel"
              },
              rowAlignment: "center"
            },
            // materialName:{
            //   title: "نام کالا",
            //   type: "text",
            //   isSearchable: true,
            //   rowAlignment: "center"
            // },
            percentage: {
              title: "مقدار",
              type: "number",
              rowAlignment: "center"
            },
            unitValue: {
              title: "واحد",
              inHeader: false,
              type: "text",
              isSearchable: false,
              rowAlignment: "center",
            },
          }
        },
        tableOptions: {
          dataSourceType: "api",
          beforeCreateEntity: input => {
            // console.log("create model....")
            // console.log(input)
            // console.log(this.mode)

            if (this.mode === "create") {
              this.updateMaterialTable(input);
              // input.id = Math.random() * 1000;
              return null;
            } else {
              if (input && input["material"]) {
                input["material"] = input["material"].id;
              }
              input.productId = this.product.id;
              return input;
            }
          },
          beforeDeleteEntity: input => {
            if (this.mode === "create") {
              this.deleteMaterialTableRow(input.id);
              return null;
            } else {
              return input;
            }
          },
          beforeFetchEntityList: input => {
            if (this.product && this.product.id)
              input.productId = this.product.id;
            return input;
          },
          hasActions: true,
          onRowClicked: row => {
          },
          hasActionsInHeader: true,
          clickableRows: true,
          onEditClicked: (row, context) => {
            //   this.productVoucherModel = row;
            //   this.productVoucherModel.type = "Edit";
            //   this.openProductDetailModal();
          },
          onRowDoubleClicked: row => {
            //   this.productVoucherModel.type = "View";
            //   this.productVoucherModel = row;
            //   this.openProductDetailModal();
          }
        }
      };
    },
    mounted() {
      // this.$store.commit("REMOVE_ALL_ROWS_FROM_VS_TABLE_FEED");
    },
    beforeMount() {
      if (this.row) {
        this.product = this.row;
        this.modalTitle = this.modalTitle + " " + this.product.productName;
      }
      if (this.$route && this.$route.path) {
        this.tableOptions.access = checkAccess(this.$route.path);
      } else {
        this.tableOptions.access = checkAccess("products");
      }
    },
    methods: {
      openModal(mode) {
        this.show = true;
        this.tableOptions.headerActionsMode = mode;
        if (mode === "create") {

          this.tableOptions.clearStoreOnMount = true;
          this.tableOptions.dataSourceType = "store";
          this.tableOptions.hasActions = true;
          this.tableOptions.hasActionsInHeader = true;
        } else {
          this.$store.commit("REMOVE_ALL_ROWS_FROM_VS_TABLE_FEED");
          this.tableOptions.dataSourceType = "api";
          if (mode === "view") {
            this.tableOptions.hasActions = false;
            this.tableOptions.hasActionsInHeader = false;
          } else {
            this.tableOptions.hasActions = true;
            this.tableOptions.hasActionsInHeader = true;
          }
        }
        if (this.$refs) {
          this.$refs.materialModal.show();
          this.$refs.materialTable &&
          this.$refs.materialTable.onFetchEntityListRequested();
        }
        this.refreshMaterialTable();
      },
      setDateFromDatePicker(date) {
        this.documentDate = date;
      },
      toggleDatePicker() {
        this.$refs.datePicker.togglePicker();
      },
      btnClicked() {
        this.$refs.materialModal.show();
        this.calculatePrependWidth();
      },
      onMaterialModalOk() {
        this.$emit(
          "dataChanged",
          this.headerKey,
          this.vsTableFeed.map(m => {
            return m;
          })
        );
        if (this.mode !== "create") {
          EventBus.$emit("materialChanged");
        }
      },
      updateMaterialTable(data) {
        this.$store.commit("ADD_ROW_TO_VS_TABLE_FEED", {
          id: Math.random() * 100,
          material: data.material,
          percentage: data.percentage
        });
        // this.voucherModel.voucherProductDto.push({
        //   productId: data.productId,
        //   unitVal: data.number || data.unitVal,
        //   price: data.price,
        //   productName: data.productName
        // });
      },
      deleteMaterialTableRow(id) {
        this.$store.commit("DELETE_ROW_FROM_VS_TABLE_FEED", id);
        this.show = false;
        setTimeout(() => {
          this.show = true;
        }, 50);
      },
      refreshMaterialTable() {
        this.show = false;
        setTimeout(() => {
          this.show = true;
        }, 50);
      }
    },
    computed: {
      ...mapState(["selectedRows", "currentService", "vsTableFeed"])
    },
    watch: {
      vsTableFeed(val) {
        //this.refreshMaterialTable();
      },
      row(val) {
        this.product = val;
        this.modalTitle = "محصولات میانی " + this.product.productName;
        if (this.mode === "create") {
          this.tableParams.dataSourceType = "store";
        } else {
          this.tableParams.dataSourceType = "api";
        }
      }
    }
  };
</script>

<style scoped>
  hr {
    background-color: rgba(255, 255, 255, 0.4);
  }

  .input-group > div:not(.custom) {
    display: flex;
    flex: 1;
  }
</style>
